import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomStreamActions } from "../actions";

export const ROOM_STREAM_FEATURE_KEY = "roomStream";

export interface RoomStreamState extends EntityState<Record<string, never>> {
  isLoading: boolean;
}

export const roomStreamAdapter: EntityAdapter<Record<string, never>> =
  createEntityAdapter();

const initialState: RoomStreamState = roomStreamAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialState,
  on(
    RoomStreamActions.roomStreamActiveDelete,
    RoomStreamActions.roomStreamActiveSet,
    RoomStreamActions.roomStreamDelete,
    RoomStreamActions.roomStreamRestart,
    RoomStreamActions.roomStreamAudioUpdate,
    (state) => {
      return {
        ...state,
        isLoading: true
      };
    }
  ),
  on(
    RoomStreamActions.roomStreamActiveDeleteFailure,
    RoomStreamActions.roomStreamActiveDeleteSuccess,
    RoomStreamActions.roomStreamActiveSetFailure,
    RoomStreamActions.roomStreamActiveSetSuccess,
    RoomStreamActions.roomStreamDeleteFailure,
    RoomStreamActions.roomStreamDeleteSuccess,
    RoomStreamActions.roomStreamRestartFailure,
    RoomStreamActions.roomStreamRestartSuccess,
    RoomStreamActions.roomStreamAudioUpdateFailure,
    RoomStreamActions.roomStreamAudioUpdateSuccess,
    (state) => {
      return {
        ...state,
        isLoading: false
      };
    }
  )
);

export function roomStreamReducer(
  state: RoomStreamState | undefined,
  action: Action
) {
  return reducer(state, action);
}
